import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid'
import { ColoredRectangleContainer } from '../../styles/base'
import variables from '../../styles/variables'
import { Heading } from '..'
import { headerStyles } from '../../styles/global'

export const Container = styled(ColoredRectangleContainer)`
  background: #C4CED5;
  position: relative;
  padding: 40px 20px 80px 20px;
  flex: 0 1 100%; /* Fix IE layout bug */
  width: 100%;

  @media ${variables.media.sm} {
    margin: 30px 0;
    padding: 100px 100px 80px 100px;
    max-width: ${variables.maxContentWidth + 300}px;
  }
`
export const UseCaseCardHeader = styled(Heading)`
  ${headerStyles.headerSmall};
  color: #494B6A;
`
export const UseCaseDescription = styled.p`
  color: #494B6A;
  margin: 30px 0;
`
export const UseCaseBenefit = styled.p`
  color: #494B6A;
  font-weight: 600;
  font-family: ${variables.fonts.header};
`
export const UseCaseCol = styled(Col)`
  position: relative;
`
export const UseCaseInfo = styled(Col)`
  height: 100%;
  display: flex;
  flex-direction: column;
`
export const ReadMoreButton = styled.div`
  margin: 50px auto 0 auto;
  @media ${variables.media.md} {
    margin: 50px 0 0 0;
  }
`
export const IkeaImage = styled.img`
  width: 100%;
  box-shadow: 0 2px 40px rgba(49,47,47,.16);
  border-radius: 15px;
  @media ${variables.media.md} {
    width: 500px;
    position: relative;
    left: -200px;
  }
  @media ${variables.media.lg} {
    width: 530px;
    position: relative;
    left: -230px;
  }
`
